<template>
  <CenteredContent :class="$style.desktopMain">
    <Logo :class="$style.homeLogo"/>
    <div>
      <v-layout row
                justify-space-around
                align-center>
        <BaseButton button-style="Round"
                    @click="inStoreHandler">
          <svg
            v-svg
            :class="$style.outIcon"
            symbol="out-icon"
          />
          <span>Carry out</span>
        </BaseButton>
        <BaseButton button-style="Round"
                    @click="curbsideHandler">
          <svg
            v-svg
            :class="$style.curbsideIcon"
            symbol="curbside-icon"
          />
          <span>Curbside</span>
        </BaseButton>
      </v-layout>
    </div>
  </CenteredContent>
</template>

<script>
import Component from 'vue-class-component';
import CenteredContent from '@/layouts/CenteredContent';
import Logo from '@/components/Logo';
import BaseButton from '@/components/BaseButton';
import Vue from 'vue';
import { Action } from 'vuex-class';
import { ORDER_SET_TYPE } from '@/apps/cart/store/types';
import { ORDER_TYPES } from '@/config/constants';

/**
 * Desktop layout for order options.
 */
@Component({
  name:       'DesktopOptions',
  components: {
    CenteredContent,
    Logo,
    BaseButton,
  },
})
export default class DesktopOptions extends Vue {
  @Action(ORDER_SET_TYPE) setOrderType;

  /**
   * Handler for click on "Carry out" icon
   */
  inStoreHandler() {
    this.setOrderType(ORDER_TYPES.inStore);
    this.$router.push({ name: 'menu' });
  }

  /**
   * Handler for click on "Curbside" icon
   */
  curbsideHandler() {
    this.setOrderType(ORDER_TYPES.curbside);
    this.$router.push({ name: 'menu' });
  }

  /**
   * reset selected order type and rest
   */
  mounted() {
    this.setOrderType(null);
  }
}
</script>

<style lang="scss" module>
.desktopMain {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.homeLogo {
  margin-bottom: 27px;
  text-align: center;
  max-width: 169px;
}

.outIcon {
  width: 48.5px;
  height: 48.5px;
}

.curbsideIcon {
  width: 62px;
  height: 32px;
}

@media screen and (max-width: 480px) {
  .outIcon {
    width: 30px;
    height: 30px;
    margin-bottom: 10px;
  }
  .curbsideIcon {
    width: 50px;
    height: 24px;
    margin-bottom: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/apps/desktop/components/DesktopOptions.vue